import { type IconName } from '@cencosud-cencommerce/paris-uikit';

import { LABEL_CHANGE_COPEC } from '@/sections/shippingMethods/mappers/constants';

const deliveryList = [
  {
    id: 1,
    title: 'Entrega 1 de 2',
    iconName: 'il-product',
    saleTagLabel: 'vendida por',
    saleTagStoreName: 'Paris.cl',
    intangible: false,
    productList: [
      {
        productId: '35f37154-5cae-4f4f-87d4-0db965e32f70',
        imageUrl:
          'https://www.paris.cl/dw/image/v2/BCHW_PRD/on/demandware.static/-/Sites-cencosud-master-catalog/default/dw03ddc224/images/imagenes-productos/625/941447-0000-002.jpg?sw=230',
        name: 'Perfume Polo Blue EDP Hombre 75 ml',
        onDelete: (id: string) => console.log(id),
        saleTagProps: {
          storeName: 'paris.cl',
          label: 'Vendido por:'
        },
        specs: [
          {
            label: 'Tamaño',
            value: '75ml'
          },
          {
            label: 'Color',
            value: 'Azul'
          }
        ],
        samples: [
          {
            title: 'Parche Ojos Cansados Aloe Vera Laction',
            imageUrl:
              'https://www.paris.cl/dw/image/v2/BCHW_PRD/on/demandware.static/-/Sites-cencosud-master-catalog/default/dwb74076ef/images/imagenes-productos/626/480755-0000-002.jpg'
          }
        ]
      },
      {
        productId: '2',
        imageUrl:
          'https://www.paris.cl/dw/image/v2/BCHW_PRD/on/demandware.static/-/Sites-cencosud-master-catalog/default/dw4700e059/images/imagenes-productos/625/521165-0000-002.jpg?sw=230',
        name: 'Perfume Polo Red EDP Hombre 125 ml',
        onDelete: (id: string) => console.log(id),
        saleTagProps: {
          storeName: 'paris.cl',
          label: 'Vendido por:'
        },
        specs: [
          {
            label: 'Tamaño',
            value: '75ml'
          },
          {
            label: 'Color',
            value: 'Rojo'
          }
        ]
      },
      {
        productId: '3',
        imageUrl:
          'https://www.paris.cl/dw/image/v2/BCHW_PRD/on/demandware.static/-/Sites-cencosud-master-catalog/default/dw3df263de/images/imagenes-productos/703/133501-0000-001.jpg',
        name: 'LED Smart TV 50 4K UHD TV 50UR7',
        onDelete: (id: string) => console.log(id),
        saleTagProps: {
          storeName: 'paris.cl',
          label: 'Vendido por:'
        },
        specs: [
          {
            label: 'Color',
            value: 'Negro'
          }
        ],
        services: [
          {
            title: 'Garantia',
            type: 'warranty',
            amount: '1 | 1 año'
          },
          {
            title: 'Armado',
            type: 'assembly',
            amount: '1 '
          },
          {
            title: 'Recicambio',
            type: 'recicambio',
            amount: '1'
          }
        ]
      },
      {
        productId: '4',
        imageUrl:
          'https://www.paris.cl/dw/image/v2/BCHW_PRD/on/demandware.static/-/Sites-cencosud-master-catalog/default/dw887ce77d/images/imagenes-productos/743/440437-0000-001.jpg',
        name: 'Consola PS5 con Disco',
        onDelete: (id: string) => console.log(id),
        saleTagProps: {
          storeName: 'paris.cl',
          label: 'Vendido por:'
        },
        specs: [
          {
            label: 'Color',
            value: 'Blanco'
          }
        ]
      }
    ],
    pickupOptions: [
      {
        title: 'Paris Quilicura',
        brand: 'paris',
        cta: {
          iconName: 'il-paris' as IconName,
          label: 'Elegir otra tienda Cencosud',
          onClick: () => {
            console.log('cta card 1');
          }
        },
        description1Label: 'Retira desde:',
        description1Value: '10 de enero',
        description2: 'Av. O"Higgins 581, Quilicura',
        isFree: true,
        radioButton: {
          id: 'test-1',
          name: 'test',
          value: 'test-1',
          onChange: () => {}
        },
        showBorder: false
      },
      {
        id: 2,
        title: 'Copec',
        brand: 'copec',
        cta: {
          iconName: 'il-store' as IconName,
          label: LABEL_CHANGE_COPEC,
          onClick: () => {
            console.log('cta card 2');
          }
        },
        description1Label: 'Retira desde:',
        description1Value: '10 de enero',
        description2: 'Av. O"Higgins 581, Quilicura',
        price: '$3,990',
        radioButton: {
          id: 'test-2',
          name: 'test',
          value: 'test-2',
          onChange: () => {}
        },
        showBorder: false
      }
    ],
    shippingOptions: [
      {
        label: 'Recibe mañana:',
        date: '10 de enero',
        description: '¿En qué horario?',
        id: '2024-01-10',
        selected: false,
        chips: [
          {
            label: '9:00-12:00',
            value: '9:00-12:00',
            onClick: () => {},
            disabled: false,
            selected: false
          },
          {
            label: '13:00-18:00',
            value: '13:00-18:00',
            onClick: () => {},
            disabled: false,
            selected: false
          },
          {
            label: '18:00-21:00',
            value: '18:00-21:00',
            onClick: () => {},
            disabled: false,
            selected: false
          }
        ],
        onChange: () => {}
      },
      {
        label: 'Recibe hoy:',
        date: '9 de enero',
        price: '$7.990',
        isFlash: true,
        description: '¿En qué horario?',
        id: '2024-01-09',
        selected: true,
        chips: [
          {
            label: '9:00-12:00',
            value: '9:00-12:00',
            onClick: () => {},
            disabled: true,
            selected: false
          },
          {
            label: '13:00-18:00',
            value: '13:00-18:00',
            onClick: () => {},
            selected: true,
            disabled: false
          },
          {
            label: '18:00-21:00',
            value: '18:00-21:00',
            onClick: () => {},
            disabled: false,
            selected: false
          }
        ],
        onChange: () => {}
      }
    ]
  },
  {
    title: 'Entrega 2 de 2',
    iconName: 'il-product',
    intangible: true,
    productList: [
      {
        productId: '3',
        imageUrl:
          'https://www.paris.cl/dw/image/v2/BCHW_PRD/on/demandware.static/-/Sites-cencosud-master-catalog/default/dwd4f4bacf/images/imagenes-productos/743/639349-0000-002.jpg?sw=230',
        name: 'Playstation card',
        onDelete: (id: string) => console.log(id),
        saleTagProps: {
          storeName: 'paris.cl',
          label: 'Vendido por:'
        }
      }
    ]
  }
];

export default deliveryList;
